import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { TenantCertificationDetailsComponent } from '../tenant-certification-details/tenant-certification-details.component';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { UrlService } from 'src/app/services/util/url.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-tenant-certification',
    templateUrl: './tenant-certification.component.html',
    styleUrls: ['./tenant-certification.component.scss'],
    standalone: false
})
export class TenantCertificationComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  Constants = Constants;
  certificationNonPii: any;
  certificationPii: any;
  tenantId: any;
  isLoading: boolean;
  certificationData: any;
  accountData: any;
  subscriptionIdPii: any;
  subscriptionIdNonPii: any;
  accountIdNonProdPii: any;
  accountIdProdPii: any;
  accountIdNonPii: any;
  prodCertificateCreation: boolean;
  blueprints: any;
  selectedValue: any;
  tableView: boolean;
  tableData: any;
  dataSource: any;
  nonProd: any;
  prod: any;
  prodTss: any;
  tenantData: any;
  loading = true;
  dataLoading = true;
  displayedColumns: string[] = ['name', 'type', 'serviceDefinition', 'status', 'menu'];

  constructor(private route: ActivatedRoute,
    private router: Router, private urlService: UrlService, private authService: AuthService,private blueprintsService: BlueprintsService, private sidenavService: SidenavService, private toastrService: CustomToastrService,
    private tenantService: TenantService, private dialog: MatDialog, private permissionsService: PermissionsService, private instanceService: InstancesService) {
    
  }
  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'LEFT_SIDE_NAV.CERTIFICATE';
    const tenant = this.authService.principal.provider;
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', tenant, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.tenantId = this.route.snapshot.params.id;
    if(this.tenantId) {
      this.isLoading = true;
      this.loadData(this.tenantId);
    }
  }

  loadData(tenantId): void {
    this.subscriptionIdPii = '';
    this.subscriptionIdNonPii = '';
    this.tenantService.getTenantAccountDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.loading = false;
          this.accountData = data;
          this.accountData?.forEach(item => {
            if(item?.azureDetails) {
              if(item?.dataZone === SubscriptionTypes.PII) {
                this.subscriptionIdPii = item?.azureDetails?.subscriptionId;
              } else if(item?.dataZone === SubscriptionTypes.NONPII) {
                this.subscriptionIdNonPii = item?.azureDetails?.subscriptionId;
              }
            }
            if(item?.awsDetails) {
              if(item?.dataZone === SubscriptionTypes.NONPII) {
                this.accountIdNonPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.PII){
                this.accountIdNonProdPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.PROD){
                this.accountIdProdPii = item?.awsDetails?.accountId;
              }
            }
          });
        }
      });
      this.blueprintsService.getBlueprints(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (blueprints: any) => {
          blueprints = blueprints?.sort((a, b) => new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime() ? -1 : 1);
          this.blueprints = blueprints?.filter(item => item?.tenantId === this.tenantId);
        }
      );
      this.tenantService.getTenantDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.tenantData = response;
        const availableService = this.tenantData.sharedServices?.['prod'];
        if (availableService && availableService?.instanceId) {
        this.instanceService.getInstanceById(this.tenantData.sharedServices?.['prod']?.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(instanceData => {
          this.tenantData.sharedServices['prod'].instanceDetails = instanceData;
          // if(this.tenantData.sharedServices['prod'].instanceDetails.status !== DeployStatus.FAILED) {
          //   this.prodCertificateCreation = true;
          // }
        });
      }
      }, (error) => {
        setTimeout(() => {
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          this.toastrService.errMessage(message, title);
        }, 500);
    });
    this.tenantService.getTenantCertificate(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.certificationData = response;
        this.getCertificates();
        this.certificationData.forEach(item => {
          if (item.type === 'nonprod' && ['ready', 'created'].includes(item.status?.toLowerCase())) {
            this.prodCertificateCreation = true;
          }
        });
        }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      })
  }

    getCertificates(): void {
          this.nonProd;
          this.prodTss;
          this.prod = []
          this.certificationData.filter((item) => {
              if (item.type === 'prod') {
                this.prod.push(item);
              } else if(item.type === 'nonprod') {
                this.nonProd = item;
              } else if(item.type === 'prod_identity') {
                this.prodTss = item;
              }
            });
          this.prod?.forEach(cert => {
            const domain = cert?.details?.domain?.split('.')[0];
            if (this.blueprints?.find(item => item?.name?.toLowerCase() === domain?.toLowerCase())) {
              this.blueprints.find(item => item?.name?.toLowerCase() === domain?.toLowerCase()).disabled = true;
            }
          });
          this.dataLoading = false;
          this.dataSource = new MatTableDataSource(this.prod);     
        }

    valueChanged(value): void {
      this.selectedValue = value;
    }

    labelClick(): void {
      setTimeout(() => {
        if (document.getElementsByClassName("blueprint-dropdown")) {
          const element = <HTMLElement> document.getElementsByClassName("blueprint-dropdown")[0];
          if (element) {
            element.classList.add("margin-style");
          }
        }
      }, 100);
    }

    onViewClick(response): void {
      if(response) {
        this.dialog.open(TenantCertificationDetailsComponent, {
          minHeight: '366px',
          width: '678px',
          panelClass: 'flex-dialog',
          data: response
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if (result) {
          }
        });
      }
    }

    onCreateClick(data): void {
    const message = (data === SubscriptionTypes.PROD_IDENTITY ? translate('TENANT_DETAILS.CERT_MESSAGE_PROD_IDENTITY') : ( data === 'PROD' ? translate('TENANT_DETAILS.CERT_MESSAGE_PROD') : translate('TENANT_DETAILS.CERT_MESSAGE_NON_PROD')));
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.CREATE_CERTIFICATE'),
        message: message,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        let requestData;
        if(data === 'PROD') {
          this.tableView = true;
          requestData = 'prod'
        } else {
          const request = (data === 'NONPII' ? 'nonprod' : 'prod_identity')
          requestData = request;
        }
        this.tenantService.postTenantCertificate(this.tenantId, requestData).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          this.loadData(this.tenantId);
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.TENANT');
              const message = translate('TENANT_DETAILS.CERT_MESSAGE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
        },
        (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.CREATE_CERTIFICATE_FAILED'),
            description: errorMessage
          }})
        });
      }
    });
  }


  openUrl(): void {
    this.urlService.openUrlInNewTab('https://dashboard.bankingcloud.temenos.com/userguide/docs/home/support');
  }
}
